module.exports = __webpack_public_path__ + "static/media/教育行业解决方案.cbbd86c8.png";